import { Col, Modal, Row } from 'antd'
import styles from './index.module.less'
import { ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons'
import { useSetState } from 'ahooks'
import classNames from 'classnames'

const AccountSelection = props => {
  const { open, data, onClose, onOk } = props

  const [state, setState] = useSetState({
    loadingId: null,
  })

  const handleOk = record => {
    setState({ loadingId: record.tenantId })
    onOk?.(record)
      .then(() => {
        onClose?.()
      })
      .finally(() => {
        setState({ loadingId: null })
      })
  }

  return (
    <div className={styles.selectionWrap}>
      <div className={styles.selectionTips}>检测到您存在多个租户内，请选择一个租户进行登录</div>
      <div className={styles.tenantSelection}>
        {data?.map?.((d, i) => {
          const loading = state.loadingId === d.tenantId
          const disabled = state.loadingId && !loading
          return (
            <div
              key={`tenant_${i}`}
              className={classNames(styles.tenantItem, {
                [styles.loading]: loading,
                [styles.disabled]: disabled,
              })}
              onClick={() => disabled ? () => {} : handleOk(d)}
            >
              <Row justify="space-between">
                <Col> {d.tenantName} - {d.userName}</Col>
                <Col>
                  <ArrowRightOutlined />
                </Col>
              </Row>
              {loading ? (
                <div className={styles.loading}>
                  <LoadingOutlined />
                </div>
              ) : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const AccountSelectionModal = props => {
  const { open, onClose } = props
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="租户选择"
      footer={null}
      maskClosable={false}
      width={484}
      centered
      style={{ marginLeft: '50vw' }}
    >
      <AccountSelection {...props} />
    </Modal>
  )
}

export default AccountSelection
